import { useMemo } from "react";
import {
  CookiesEnum,
  cookiesValues,
  GamificationPlanIdEnum,
} from "@/constants/constants";
import { getClientSideCookieValue } from "@/utils/common.helpers";
import { useUserContext } from "@/context/UserProvider";

/**
 * Custom hook to check if a content is special access content (client-side)
 * @param contentId - The content ID to check against special access content ID
 * @returns Object containing isSpecialAccessEnabled, specialAccessContentId, and isSpecialAccessContent
 */
export const useSpecialAccess = (contentId?: string | number | null) => {
  const { hasActiveAccess, isInternational } = useUserContext();
  const trialPlanId = getClientSideCookieValue(
    cookiesValues[CookiesEnum.TrialPlanId],
  );
  // Disable special access for international users
  const isSpecialAccessEnabled =
    !isInternational && trialPlanId === GamificationPlanIdEnum.SPECIAL_ACCESS;
  const specialAccessContentIds =
    decodeURIComponent(
      getClientSideCookieValue(
        cookiesValues[CookiesEnum.SpecialAccessContentIds],
      ) || "",
    )?.split(",") || [];

  const isSpecialAccessContent = useMemo(() => {
    if (
      !contentId ||
      !isSpecialAccessEnabled ||
      !specialAccessContentIds ||
      hasActiveAccess
    ) {
      return false;
    }
    return specialAccessContentIds.includes(contentId.toString());
  }, [contentId, isSpecialAccessEnabled, specialAccessContentIds]);

  return {
    isSpecialAccessEnabled,
    specialAccessContentIds,
    isSpecialAccessContent,
  };
};
